import React, { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";
import ErrorMessage from "../../components/ErrorMessage";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";

const initialData = {
    name: "",
};

const PlayerBaseForm = ({ baseId = null, onSuccess, onClose }) => {
    const { t } = useTranslation();
    const api = useAxios();

    const [formData, setFormData] = useState(initialData);
    const [errors, setErrors] = useState({});
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        if (baseId) {
            api.get(`/api/v1.0/players/base/${baseId}/`)
                .then(res => {
                    setFormData({
                        name: res.data.name || "",
                    });
                })
                .catch(err => console.error(err))
                .finally(() => {
                    setTimeout(() => setLoader(false), 200);
                });
        } else {
            setFormData(initialData);
            setLoader(false);
        }
    }, [baseId]);

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async e => {
        e.preventDefault();
        try {
            const response = baseId
                ? await api.patch(`/api/v1.0/players/base/${baseId}/`, formData)
                : await api.post(`/api/v1.0/players/base/`, formData);

            onSuccess?.(response.data);
            toast.success(
                t(baseId ? "Data updated successfully" : "Player base created successfully")
            );
            onClose?.();
        } catch (error) {
            console.error("Player base save error", error);
            setErrors(error.response?.data || {});
        }
    };

    const handleDelete = async e => {
        e.preventDefault();
        const confirmed = window.confirm(t("Are you sure you want to delete this base?"));
        if (!confirmed) return;

        try {
            await api.delete(`/api/v1.0/players/base/${baseId}/`);
            toast.success(t("Player base deleted successfully"));
            onSuccess?.();
            onClose?.();
        } catch (error) {
            console.error("Delete error", error);
            toast.error(t("Error deleting player base"));
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <h2>
                <FeatherIcon icon="folder" />
                {baseId ? t("Edit player base") : t("Create player base")}
            </h2>

            <div className="form-group">
                <label>{t("Name")}</label>
                {loader ? (
                    <Skeleton height={42} width="100%" baseColor="#f8f7fa" />
                ) : (
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="form-control"
                    />
                )}
                <ErrorMessage error={errors.name && t(errors.name)} />
            </div>

            <br />

            <ul className="tabs">
                <li>
                    <a
                        href="#"
                        className="action-button"
                        onClick={e => {
                            e.preventDefault();
                            e.currentTarget.closest("form").requestSubmit();
                        }}
                    >
                        <FeatherIcon icon="check" /> {t("Save")}
                    </a>
                </li>

                {baseId && (
                    <li>
                        <a href="#" className="action-button" onClick={handleDelete}>
                            <FeatherIcon icon="trash-2" /> {t("Delete")}
                        </a>
                    </li>
                )}
            </ul>
        </form>
    );
};

export default PlayerBaseForm;
